import React from 'react';
import Baozufang from './baozufang';
import request from '../../../service/request';
import { BAOZUFANG_GET_DETAIL, BAOZUFANG_GET_TYPE } from '../../../service/api';

async function action ({ query, cookie }) {
    if(query.id) {
        const [houseData, typeData] = await Promise.all([
            request.GET({
                url: BAOZUFANG_GET_DETAIL + query.id,
                headers: cookie ? {
                    cityCode: cookie['cityCode'] || 420200
                } : {}
            }),
            request.POST({
                url: BAOZUFANG_GET_TYPE,
                params: {
                    bzfEstateInfoId: query.id,
                }
            })
        ]);
        if(houseData.code != 0) {
            return
        }
        if(!houseData.data.latitude || !houseData.data.longitude){
            houseData.data.latitude = '31.299758'
            houseData.data.longitude = '120.585294'
        }

        const pData = {
            id: query.id || '',
            houseInfo: houseData.data || null,
            pageCode: houseData.code,
            typeData: typeData.data,
        }
        return {
            title: pData.houseInfo ? `${pData.houseInfo.estateName}_东楚优房` : '东楚优房',
            chunks: ['baozufang'],
            component: (
                <Baozufang pagedata={pData} />
            )
        };
    }
}
export default action;
